module.exports = __webpack_public_path__ + "img/github.49fe11a4.svg";